import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import { PulseLoader } from "react-spinners";
import { OLD_UI_URL } from '../../services/api/api-client';
import { GetWordProjectDocPreview } from "../../services/api/task-api";
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectDocPath, selectOriginalDocPath, selectDocPathBlackline, selectIsLoadingDocument } from "../../redux/tasks/task-selector";
import './documentViewer.styles.scss';

const DocumentViewer = ({
  task,
  auditTrail,
  auditTrailComment,
  downloadAuditTrailFile,
  showDocumentViewer,
  setShowDocumentViewer,
  document: { documentName, AssignmentType },
  title,
  docPath,
  originalDocPath,
  docPathBlackline,
  isLoadingDocument,
  updatedDocName,
}) => {
  const documentTitleType = title.split(" ")[0];
  //backline controls
  const [toggleBlackline, setToggleBlackline] = useState(false);
  const handleBlackline = () => setToggleBlackline(!toggleBlackline);
  //modal controls
  const handleClose = () => {
    setShowDocumentViewer(false);
    setToggleBlackline(false);
  };

  //download function
  const downloadUpdatedDoc = async () => {
    if (documentTitleType === "Live") {
      let doc = await GetWordProjectDocPreview(task.Id);
      window.location = doc;
    } else if (AssignmentType === "row" || AssignmentType === "column") {
      window.location =
        OLD_UI_URL + "/ApplicationDocuments/Files/" + documentName;
    } else {
      window.location =
        OLD_UI_URL + "Home/DownloadOriginalDoc?filename=" + updatedDocName;
    }
  };

  //modal classname
  const getClassName = () => {
    // excel row - changed content / updated content (with blackline)
    if (AssignmentType === "row" &&
      ((originalDocPath.length > 0 && originalDocPath !== "") ||
        toggleBlackline)
    ) {
      return "document-viewer-double-row";
    }
    // excel row - assigned content / updated content (no blackline)
    else if (AssignmentType === "row") {
      return "document-viewer-row";
    }
    // word - updated content (with blackline)
    // excel column - changed content / updated content (with blackline)
    else if (
      (originalDocPath.length > 0 && originalDocPath !== "") ||
      toggleBlackline
    ) {
      return "document-viewer-double";
    }
    // word - assigned content / changed content / updated content (no blackline)
    // excel column - assigned content / updated content (no blackline)
    else {
      return "document-viewer";
    }
  };

  return (
    <Modal
      show={showDocumentViewer}
      onHide={() => handleClose()}
      dialogClassName={getClassName()}
    >
      <Modal.Header>
        <Modal.Title className="document-viewer-title">
          {auditTrail
            ? title
            : `View ${documentTitleType} ${
                documentTitleType === "Updated" || documentTitleType === "Live"
                  ? " Document"
                  : " Content"
              }`}
        </Modal.Title>
        <div>
            { //only display blackline button for updated content
                !docPathBlackline.length === 0 && !docPathBlackline === "" && !isLoadingDocument &&
                <Button className="btn-wide blackline-btn" onClick={() => handleBlackline()}>
                    {toggleBlackline ? "Hide Changes" : "Show Changes"}
                </Button>
            }
            <Button className="close-document-viewer-btn" onClick={() => handleClose()}></Button>
        </div>
      </Modal.Header>
      <div className="select-member-divider-line"></div>
      <Modal.Body>
        {
          //if document still LOADING, show pulseloader
          isLoadingDocument ? (
            <div className={"document-viewer-loader-wrapper"}>
              <div
                style={{ position: "absolute", top: "250px", left: "400px" }}
              >
                <PulseLoader></PulseLoader>
              </div>
            </div>
          ) : originalDocPath.length > 0 && originalDocPath !== "" ? (
            // only for excel changed content
            <div className="document-viewer-document-wrapper">
              <iframe
                title="original Doc Path"
                className="pdf-viewer margin-one"
                src={originalDocPath}
              ></iframe>
              <iframe
                title="edited Doc Path"
                className="pdf-viewer margin-two"
                src={docPath}
              ></iframe>
            </div>
          ) : !toggleBlackline ? (
            // for everything else
            // word assigned/changed/updated
            // excel assigned/updated
            <iframe
              title="edited Doc Path"
              className="pdf-viewer"
              src={docPath}
            ></iframe>
          ) : (
            // only for updated content - show blackline
            <div className="document-viewer-document-wrapper">
              <iframe
                title="edited Doc Path"
                className="pdf-viewer margin-one"
                src={docPath}
              ></iframe>
              <iframe
                title="original Doc Path"
                className="pdf-viewer margin-two"
                src={docPathBlackline}
              ></iframe>
            </div>
          )
        }
        {   !isLoadingDocument && //if document still LOADING, don't show buttons
            <div className="btn-container">
              { // audit trail document viewer does not have back button
                !auditTrail &&
                <Button className="btn-wide btn-outlined back-btn" onClick={() => handleClose()}>
                    Back
                </Button>
              }
              { // only show download button for updated doc
                docPathBlackline.length > 0 && docPathBlackline !== "" &&
                <Button className="btn-wide download" onClick={() => downloadUpdatedDoc()}>
                    Download
                </Button>
              }
              { // only show download button for document viewer for audit trail
                auditTrail &&
                <Button className="btn-wide download"
                    onClick={() => {
                        console.log(auditTrailComment);
                        downloadAuditTrailFile(auditTrailComment.documentLst, auditTrailComment);
                    }}
                >
                    Download
                </Button>
              }
            </div>
        }
      </Modal.Body>
    </Modal>
  );
};

DocumentViewer.propTypes = {
  task: PropTypes.object.isRequired,
  auditTrail: PropTypes.bool.isRequired,
  auditTrailComment: PropTypes.object.isRequired,
  downloadAuditTrailFile: PropTypes.func.isRequired,
  showDocumentViewer: PropTypes.bool.isRequired,
  setShowDocumentViewer: PropTypes.func.isRequired,
  document: PropTypes.shape({
    documentName: PropTypes.string.isRequired,
    AssignmentType: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  docPath: PropTypes.string.isRequired,
  originalDocPath: PropTypes.string.isRequired,
  docPathBlackline: PropTypes.string.isRequired,
  isLoadingDocument: PropTypes.bool.isRequired,
  updatedDocName: PropTypes.string.isRequired,
};

const mapState = createStructuredSelector({
    docPath: selectDocPath,
    originalDocPath: selectOriginalDocPath,
    docPathBlackline: selectDocPathBlackline,
    isLoadingDocument: selectIsLoadingDocument
})

export default connect(mapState, null)(DocumentViewer);
